export { Model as ServiceSlotModel } from './model'
export { Store as ServiceSlotStore } from './store'
